import * as React from 'react';

import { App } from '@frontend/app/containers';
import { AuthProvider } from '@frontend/context/authContext';

const Main: React.FC<React.PropsWithChildren<unknown>> = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default Main;
